module.exports = __webpack_public_path__ + "img/logo-brand.b7f908bc.svg";